import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const RoundRobinIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7563 11.6313C11.098 11.2896 11.652 11.2896 11.9937 11.6313L15.75 15.3876L19.5063 11.6313C19.848 11.2896 20.402 11.2896 20.7437 11.6313C21.0854 11.973 21.0854 12.527 20.7437 12.8687L16.3687 17.2437C16.027 17.5854 15.473 17.5854 15.1313 17.2437L10.7563 12.8687C10.4146 12.527 10.4146 11.973 10.7563 11.6313Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.748 5.25C16.2313 5.25 16.6231 5.64174 16.6231 6.125V16.625C16.6231 17.1083 16.2313 17.5 15.748 17.5C15.2648 17.5 14.873 17.1083 14.873 16.625V6.125C14.873 5.64174 15.2648 5.25 15.748 5.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.875C0 7.39174 0.391756 7 0.875002 7H8.75002C9.23328 7 9.62502 7.39174 9.62502 7.875C9.62502 8.35826 9.23328 8.75 8.75002 8.75H0.875002C0.391756 8.75 0 8.35826 0 7.875Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.875001C0 0.391755 0.391756 0 0.875001 0H15.75C16.2333 0 16.625 0.391755 16.625 0.875001C16.625 1.35825 16.2333 1.75 15.75 1.75H0.875001C0.391756 1.75 0 1.35825 0 0.875001Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 14.875C0 14.3917 0.391756 14 0.875002 14H7.00001C7.48328 14 7.87502 14.3917 7.87502 14.875C7.87502 15.3583 7.48328 15.75 7.00001 15.75H0.875002C0.391756 15.75 0 15.3583 0 14.875Z"
        fill="currentColor"
      />
    </svg>
  )
})

RoundRobinIcon.displayName = 'RoundRobinIcon'
